import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'
import { LeftPaneStyleProps } from '../components/LeftMostPane/LeftMostPane'

export const leftMostPaneStyles = makeStyles((theme: Theme) => ({
    tabLabel: {
        fontSize: pxToRem(13),
        textTransform: 'uppercase',
        width: pxToRem(75),
        textAlign: 'justify',
        lineHeight: pxToRem(15),
    },
    collapseIcon: {
        cursor: 'pointer',
        position: 'absolute',
        right: 20,
        top: 20,
    },
    closeButtonBeta: {
        cursor: 'pointer',
        position: 'absolute',
        right: 0,
        top: 8,
        color: '#185E8E',
        fontSize: 14,
    },
    defaultTextColor: {
        color: '#A78966',
    },
    selectedTabText: {
        color: '#04325B',
    },
    tabBorder: {
        borderBottom: '1px solid #DADADA',
    },
    selectedTab: {
        borderBottom: '3px solid #304959',
    },
    tabRoot: {
        minWidth: pxToRem(125),
        maxWidth: pxToRem(125),
    },
    fullWidthLeftPaneKeynotesContainer: {
        borderRadius: '5px 0 0 5px',
        border: '1px solid #C6C6C6',
        borderLeft: 'none',
        position: 'relative',
        width: 'auto',
        maxWidth: (props: LeftPaneStyleProps) =>
            props.showLeftMostPane ? pxToRem(468) : pxToRem(40),
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
        '&:focus': {
            backgroundColor: theme.palette.common.white,
        },
        '&::-webkit-scrollbar': {
            width: 6,
            height: 6,
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#464646',
            borderRadius: 100,
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'none',
            marginTop: theme.spacing(2.5),
        },
        transition: 'width 330ms ease-in-out',

        minWidth: (props: LeftPaneStyleProps) =>
            props.showLeftMostPane ? 323 : 40,
    },
    resizable: {
        position: 'relative',
        height: '100% !important',
        '& .react-resizable-handle': {
            position: 'absolute',
            width: 20,
            height: 90,
            top: '35vh',
            right: 0,
            background: 'transparent',
            backgroundPosition: 'bottom right',
            padding: theme.spacing(0.25),
            backgroundRepeat: 'no-repeat',
            backgroundOrigin: 'content-box',
            backgroundSize: 'cover',
            boxSizing: 'border-box',
            cursor: 'col-resize',
        },
    },

    buttonContainer: {
        width: pxToRem(40),
        background: '#D9E0ED',
        paddingTop: pxToRem(16),
        textAlign: 'center',
    },
    leftPaneButton: {
        margin: pxToRem(3),
        marginBottom: pxToRem(10),
        width: pxToRem(24),
        height: pxToRem(24),
        borderRadius: pxToRem(4),
        color: '#ffffff',
    },
    leftPaneIconActive: {
        fill: '#ffffff',
    },
    activeLeftPane: {
        background: '#185E8E',
        '&:hover': {
            background: '#185E8E',
        },
    },
    leftPaneIcon: {
        fill: '#185E8E',
    },
    leftPaneIconDisabled: {
        fill: '#185E8E50',
    },

    leftPaneInnerContainer: {
        height: '100%',
        width: '100%',
        background: '#EDF0F6',
    },
    collapseExpandButton: {
        cursor: 'pointer',
        color: '#04325B',
        width: '100%',
        height: 40,
        background: '#F5F5F5',
        borderRadius: 0,
        transition: '100ms',
        borderBottom: '1px solid #DADADA',
        paddingLeft: pxToRem(4),
        '& > .MuiButton-label': {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            '& > span': {
                fontSize: pxToRem(14),
                fontWeight: '500',
                textTransform: 'uppercase',
            },
        },
    },
    keynoteText: {
        textAlign: 'center',
    },
    spacer: {
        flexGrow: 1 /* Take up the remaining space */,
    },
    askDelaButton: {
        position: 'absolute',
        bottom: '12px',
    },
    elementTypeFilterContainer: {
        padding: theme.spacing(1.25, 1),
        borderBottom: '1px solid #DDDDDD',
        maxWidth: (props: LeftPaneStyleProps) =>
            props.outerPanelWidth ?? 'auto',
    },
    elementFilterChip: {
        minWidth: 132,
        height: 26,
        border: '1px solid #B5C7EA',
        color: '#314959',
        borderRadius: 100,
        padding: theme.spacing(0.625, 0),
        fontSize: pxToRem(12),
        backgroundColor: 'transparent',
        '& .MuiSvgIcon-root': {
            fontSize: pxToRem(14),
            color: '#314959',
            marginBottom: theme.spacing(0.25),
            cursor: 'pointer',
        },
        marginLeft: theme.spacing(0.625),
        marginTop: theme.spacing(0.25),
        marginBottom: theme.spacing(0.25),
    },
    '& .resize': {
        background: '#444857',
        height: '100%',
        width: 14,
        cursor: 'col-resize',
        flexShrink: 0,
        position: 'relative',
        zIndex: 10,
        userSelect: 'none',
        '& :bofore': {
            content: '',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 3,
            height: 15,
            borderInline: '1px solid #fff',
        },
    },
    expandCollapseIcon: {
        position: 'absolute',
        bottom: theme.spacing(1),
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    collapseIconContainer: {
        width: 32,
    },
    expandIconContainer: {
        width: '100%',
    },
    expandIconLeftPane: {
        transform: 'rotateY(180deg)',
    },
}))
